import { useNavigate, useParams } from 'react-router-dom';
import React, { useState, useEffect} from 'react';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
import "../assets/css/styles.table.css"
import Box from '@mui/material/Box';
import {apiUrl} from './UrlParam'; 
import ConfirmationButton from '../components/ConfirmationButton';
import AxiosFetchData from './AxiosFetchData.js'
import VirtualizedSelect from 'react-virtualized-select';
import { alertTitleClasses, Button } from '@mui/material';
import Layout from './Layout.js';
import Helper from './Helper.js';
import DeleteIcon from '@mui/icons-material/Delete';
import ProductDialog from '../components/ProductDialog.js';
import InvoiceDialog from '../components/InvoiceDialog.js';
import {calcHeight, calcHeight2, handleAdd, GetCode, CalculateTotalSubDetail, GetTotal1, GetTotal2, GetTotal3, handleAddRealization} from '../hook/RakHook.js';
import Bindcomponent from '../utils/bindcomponent.js';

const Rak = () => {
  const { id } = useParams();
  const [name, setName] = useState('');
  const [token, setToken] = useState('');
  const [expire, setExpire] = useState('');
  const Navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [rowNumber, setRowNumber] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [selectedOptionProject,setSelectedOptionProject] = useState('');
  const [unitList, setUnitList] = useState([]);
  const [selectedOptionUnit,setSelectedOptionUnit] = useState('');
  const [txt,setTxt] =  useState([]);
  const [qty,setQty] =  useState([]);
  const [isExist,setIsExist] = useState(false);
  const [isDataExist,setIsDataExist] = useState(false);
  const [total,seTotal] =  useState(0)
  const [acct,setAcct] =  useState(0)
  const [checked, setChecked] = React.useState(false);
  const [totalBelanja,seTotalBelanja] =  useState(0)
  const [role,setRole] =  useState('')
  const [userID,setUserID] =  useState('')
  const [userName,setUserName] =  useState('')
  const [isLocked,seIsLocked] =  useState(null)
  const [message,setmessage] =  useState('')
  const [tipe,settipe] =  useState('')
  const [createRak,setCreateRak] =  useState(true)
  const [totalBelanjaTemp,seTotalBelanjaTemp] =  useState(0)
  const [acctTemp,setAcctTemp] =  useState(0)
  const [code,setCode] =  useState([])
  const [codeRow,setCodeRow] =  useState('')
  const [revRow,setRevRow] =  useState('')
  const [totalPo,setTotalPo] =  useState(0)
  const [productopen,setProductopen] =  useState(0)
  const [invoiceopen,setInvoiceopen] =  useState(0)
  const [waitingApproval,setWaitingApproval] =  useState(0)
  const [realizationList, setRealizationList] = useState([]);
  const [roleAccess, setRoleAccess] = useState([]);

  var sisaAcct = 0;

  const fetchData =  async (id, locked=null) => {
    try {
     const response = await AxiosFetchData.get(`GetQuotationById/${id}/rak`).refreshToken(Navigate,"rak");
    
    if(response){
      const rowsWithRowNumbers = response.data.map((row, index) => ({
        ...row,
        rowNumber: index + 1,
        id : Math.random().toString().split('.')[1],
       
        newhpp : row.product_type == 2 ? 0 : row.hpp,
        newtotal : row.product_type == 2 ? 0 :row.hpp_total,
        othercost : row.product_type == 2 ? 0 : row.othercost,
        newhpp2 : 0,
        newqty2 : 0,
        newtotal2 : 0,
        isDb : true,
        isChecked : false
      }));
     
    setRoleAccess(response.roleaccess)
    setRole(response.decode.role)
    setUserName(response.decode.name)
    setUserID(response.decode.userID)
    setRows(rowsWithRowNumbers);
    //setCreateRak(true)
    seTotalBelanja(0)
    seTotalBelanjaTemp(0)
    setAcct(0);
    setAcctTemp(0)
    GetCodeList(response.data);
    
    seIsLocked(locked);
   }
  
    } catch (error) {
      setmessage(error.message)
      settipe('errorlog')
      //console.error('Error fetching project data:', error);
     
    }
  } 
  
  const GetCodeList = (response) => {
    // var code = response.filter((item)=>item.parent_id== null);
    // var temp= [];
    // var totalPo = 0;
    // for(var i=0; i < code.length; i++) {
    //     if(temp.findIndex((x) =>x.code == code[i].code)  == -1) {
    //       var data ={
    //          code : code[i].code,
    //          total_project : code[i].totalpo
    //       }

    //       totalPo += code[i].totalpo;
    //       temp.push(data);
    //     }
    // }
    const [totalPo , temp] = GetCode(response);
    setTotalPo(totalPo) ;
    setCode(temp.sort());
  }

  const fetchData2 =  async (id, locked=null) => {
    try {
      
    const response = await AxiosFetchData.get(`GetRakById/${id}`).refreshToken(Navigate,"rak");
     
    if(response){
   
      const rowsWithRowNumbers = response.data.rak.map((row, index) => ({
        ...row,
        rowNumber: index + 1,
        id : Math.random().toString().split('.')[1],
        isDb : row.isDb,
        isChecked : row.isChecked,
      }));
    
      var ListIsChecked =  response.data.rak.filter((obj)=> obj.raktype == 'Item');
    
      var total1 = 0;
      for(var i=0; i < ListIsChecked.length;i++){
        total1 += parseInt(ListIsChecked[i].newtotal2)
      }

      setRoleAccess(response.roleaccess)
      setRole(response.decode.role)
      seTotalBelanja(total1)
      seTotalBelanjaTemp(total1)
      setCreateRak(false)
  
      setUserName(response.decode.name)
      setUserID(response.decode.userID)
  
      GetCodeList(response.data.rak);
     
      var ListIsChecked =  response.data.rak.filter((obj)=> obj.raktype == 'Service');
    
      var total2 = 0;
      for(var i=0; i < ListIsChecked.length;i++){
        total2 += parseInt(ListIsChecked[i].newtotal2)
      }
  
      setAcct(total2)
      setAcctTemp(total2)
      seIsLocked(response.data.rak[0].isLock)
   
      setRows(rowsWithRowNumbers);
      const list = response.data.realisasi.map((row, index) => ({
        ...row,
        rowNumber: index + 1, 
        id : Math.random().toString().split('.')[1],
        descriptions:  row.implementasi,
        
      }));

      setRealizationList(CalculateSaldo(list));
     
   }
      
    } catch (error) {
      setmessage(error.message)
      settipe('errorlog')
    }
  } 
  
  useEffect(() => {
    axios.get(`${apiUrl}/api/GetQuotation`)
    .then((response) => {
      const transformedOptions = response.data.map((item) => ({
        label: `${item.id} - ${item.subject}`,
        value: item.id,
      }));

     setProjectList(transformedOptions);
     var data = {
        value:id,
        label : transformedOptions.filter(item => item.value == id)[0].label,
     }
  
     handleSelectedProject(data);
    })
    .catch((error) => {
      console.error('Error fetching category data:', error);
    });

    axios.get(`${apiUrl}/api/GetUnits`)
    .then((response) => {
      const transformedOptions = response.data.map((item) => ({
        label: `${item.name}`,
        value: item.id,
      }));
      setUnitList(transformedOptions);
    
    })
    .catch((error) => {
      console.error('Error fetching category data:', error);
    });
   
  }, []);
  
 
// const columns = [
//   { field: 'rowNumber', headerName: 'No.', width: 80 },
   
//   { field: 'id', headerName: 'Card Number', width: 200 },
//   { field: 'descriptions', headerName: 'Name', width: 200 },
//   { field: 'part_no', headerName: 'Amount', width: 150 },
//   {
//     field: 'actions',
//     headerName: 'Actions',
//     width: 350,
//     renderCell: (params) => (
//       <>
//          <button
//           onClick={() => handleEdit(params.row.id)} // Pass the project ID to the edit function
//           className="btn btn-primary mr-2"
//         >
//           Edit
//         </button>
//       <button
//         onClick={() => handleDelete(params.row.id)} // this delete button
//         className="btn btn-danger"
//       >
//         Delete
//       </button>&nbsp;
       
//       </>
//     ),
//   },
// ];

async function handleSelectedProject(id, locked = null){
  try{
    setSelectedOptionProject(id)
    const resp = await AxiosFetchData.get(`GetRakByIdPrj/${id.value}`).refreshToken(Navigate,"rak");
     if(resp){
      const approvalStatus = await AxiosFetchData.get(`GetRakApprovalStatus/${id.value}`).refreshToken(Navigate);
     
      if(approvalStatus.data === 0){
          setCreateRak(false)
          setWaitingApproval(1);
      }

      if(resp.data.length > 0){
        setIsExist(true);
        await fetchData2(id.value, locked);
      }else{
        setIsExist(false);
        await fetchData(id.value, false);
      } 
     }
     
     var total= 0;
     var invoice = await AxiosFetchData.get(`GetAllInvoice/${id.value}`).refreshToken(Navigate,"rak");
     
     if(invoice){
        invoice = invoice.data.filter(invoice => invoice.status =="Paid").reduce((accumulator ,item) => {
          return total += item.total;
        }, 0)
        seTotal(total);
     }
  }catch(err){
    setmessage(err.message)
    settipe('errorlog')
  }
    

    
}

function handleText(value,id,tipe){
    let newList = Array.from(rows);
   
    let objToUpdate = newList.find((el) =>  el.id === id) // grab first element with matching id
   // console.log(objToUpdate)
    let newList2 = Array.from(realizationList);
    
    let objToUpdate2 = newList2.find((el) =>  el.id === id)
 
    if(tipe == 'qty'){
      var index = 0;
      if(value==''){
        objToUpdate.newqty = 0;
      }
      
      if(value.toString().length > (((value * 1).toString())).length){
       index = value.toString().length - (((value * 1).toString())).length
      
      }
      
      if(value.match("[0-9]") !=null) {
          objToUpdate.newqty =  value.toString().substring(index)  ;
      }
    }

    if(tipe == 'qty2'){
        objToUpdate.newqty2 = value;
    }

    if(tipe == 'hpp'){
      
      var index = 0;
      if(value==''){
        objToUpdate.newhpp = 0;
      }
      if(isNaN(value)){
        return;
      }

      if(value.toString().length > (((value * 1).toString())).length){
        index = value.toString().length - (((value * 1).toString())).length
      }
     
      if(value.match("[0-9]") !=null) {
          objToUpdate.newhpp =  value.toString().substring(index)  ;
      } 
    }

    if(tipe == 'othercost'){
      var index = 0;
      if(value==''){
        objToUpdate.othercost = 0;
      }
      if(isNaN(value)){
        return;
      }

      if(value.toString().length > (((value * 1).toString())).length){
        index = value.toString().length - (((value * 1).toString())).length
      }
     
      if(value.match("[0-9]") !=null) {
          objToUpdate.othercost =  value.toString().substring(index)  ;
      } 
    }

    if(tipe == 'hpp2'){
        objToUpdate.newhpp2 = value;
    }

    if(tipe == 'desc'){
        objToUpdate.descriptions = value;
    }

    if(tipe == 'description'){
     
      objToUpdate2.descriptions = value;
      setRealizationList(newList2)

    }


    if(tipe == 'type'){
      objToUpdate.raktype = value;
      objToUpdate.product_type = value;
    }
   
    if(tipe === 'debit')
    {
      
      if(objToUpdate2){
       
       var index = 0;
       if(value.toString().length > (((value * 1).toString())).length){
        index = value.toString().length - (((value * 1).toString())).length
       }
       
       if(value.match("/^(?:\d+(?:,\d+)*,?)?$/") !=null) {
        objToUpdate2.debit =  value.toString().substring(index)  ;
        objToUpdate2.tipe = tipe;
       }
        
      }
      setRealizationList(CalculateSaldo(newList2))
    }
    
    if(tipe ==='credit')
    {
        if(objToUpdate2){
          var index = 0;
            if(value.toString().length > (((value * 1).toString())).length){
            index = value.toString().length - (((value * 1).toString())).length
          }

          if(!isNaN(value * 1)) {
            objToUpdate2.credit =  value.toString().substring(index) ;
            objToUpdate2.tipe = tipe;
          }else{
            return;
          }
        }
        setRealizationList(CalculateSaldo(newList2))
    }
    CalculateTotal(objToUpdate, newList)
  }
 

function CalculateSaldo(newList){
    for(let i=0; i < newList.length; i++){
     var saldo;
       if(i==0){
        saldo = 0;
       }else{
        saldo = parseFloat(newList[i-1].saldo);
       }
       
      if(newList[i].tipe  =='credit'){
        newList[i].saldo = saldo - parseFloat(newList[i].credit ==0 ? 0 : parseFloat(newList[i].credit))
      }

      if(newList[i].tipe =='debit'){
        newList[i].saldo = saldo  + parseFloat(newList[i].debit ==0 ? 0 : parseFloat(newList[i].debit))
      }
    }
    return newList;
}

function CalculateTotal(objToUpdate, newList){
    if(!objToUpdate){
      return;
    }
    
    objToUpdate.newtotal = (parseInt((objToUpdate.newqty == null ? 0 : objToUpdate.newqty)) * parseInt((objToUpdate.newhpp == null ? 0 : objToUpdate.newhpp))) + parseInt(typeof objToUpdate.othercost == 'undefined' ? 0 :objToUpdate.othercost );
  
    var total = 0;
    var acct = 0;
   
    for(var i=0;i < newList.length;i++){
           if(newList[i].isChecked == true){
             total += newList[i].newtotal2
           }
    }
 
    setAcct(acct);
    setAcctTemp(acct)
    setRows(newList);
}

async function handleDel(evt,index,produk){
   const rowsWithRowNumbers = rows.filter((row) => row.id !== produk.id).map((row, index) => ({
        ...row,
        rowNumber: index + 1,
       
  }));

   setRows(rowsWithRowNumbers)
   await handleChange(rowsWithRowNumbers);
 
}

async function handleDelRealization(id){
    const rowsWithRowNumbers = realizationList.filter((row) => row.id !==  id).map((row, index) => ({
        ...row,
        rowNumber: index + 1,
       
    }));

    setRealizationList(rowsWithRowNumbers)
    CalculateSaldo(rowsWithRowNumbers)
   
}
 

// const handleAdd = (code, rev) => {
//   setRows( // Replace the state
//     [ // with a new array
//       ...rows, // that contains all the old items
//         { 
//             rowNumber: rows.length + 1, 
//             id : Math.random().toString().split('.')[1],
//             descriptions:  "",
//             name : "",
//             newqty : 0,
//             newhpp :0,
//             newtotal :0,
//             newqty2 :0,
//             newhpp2 :0,
//             newtotal2 :0,
//            // part_no : Math.random(),
//             raktype : "Service",
//             product_type:2,
//             part_no:'',
//             isDb:false,
//             isChecked : false,
//             //code : code[code.length - 1]
//             po_detail_id : -1,
//             quotation_id : null,
//             code:code,
//             rev : rev,
//             parent_id : null,
//             rakid : -1
//     },
//     ]
//   );
//  // setRows([...rows,rowsWithRowNumbers]);
// }

// const handleAddRealization = () => {
   
//   setRealizationList( // Replace the state
//     [ // with a new array
//       ...realizationList, // that contains all the old items
//         { 
//             rowNumber: realizationList.length + 1, 
//             id : Math.random().toString().split('.')[1],
//             descriptions:  "",
//             debit : 0,
//             credit : 0,
//             saldo :0,
//             tipe: '',
//             project_id : id
//        },
//     ]
//   );
// }
 

const handleSelectedUnit = (value, id) => {
    let newList = Array.from(rows);
    let objToUpdate = newList.find((el) =>  el.id === id) 
    objToUpdate.unit_id = value;
    setRows(newList);
}
 
const handleAddRakandApproval = async (type) => {
  try{
      var data={
          request_by_name: userName,
          request_by_id : userID,
          type:type ,
          project_id :id,
          items:[],
          realisasi : realizationList
      };
       
      for(var x=0; x< rows.length; x++){
        
        var subData = {
            project_id :  selectedOptionProject.value,
            descriptions : rows[x].descriptions,
            project_name : selectedOptionProject.label.split('-')[1].trim(),
            qty1 : rows[x].newqty, 
            unit1_id : rows[x].unit_id, 
            hpp1 : CalculateTotalSubDetail(rows[x], rows).totalhpp,
            total1 : CalculateTotalSubDetail(rows[x], rows).total,
            // hpp1 :   rows[x].newhpp ,
            // total1 :  rows[x].newtotal,
            cust_id : rows[x].cust_id,
            part_no : rows[x].part_no,
            product_id : rows[x].product_id,
            isChecked : rows[x].isChecked,
            isDb : rows[x].isDb,
            type : rows[x].raktype,
            product_type : rows[x].product_type,
            code :  rows[x].code,
            po_detail_id :rows[x].po_detail_id,
            quotation_id : rows[x].quotation_id,
            anggaran_tersisa : GetTotal2(rows),
            isLock :isLocked,
            rev : rows[x].rev,
            parent_id : rows[x].parent_id,
            other_cost :  rows[x].othercost,
            rakid : rows[x].rakid,
           
        }
        data.items.push(subData)
    }
  
   if(rows.length > 0){
     const response = await AxiosFetchData.post("AddRakApproval", data).refreshToken(Navigate,"rak");
     if(response){
      setmessage("Waiting for approval")
      handleSelectedProject(selectedOptionProject, isLocked)
     }
   }else{
    setIsDataExist(true);
    setmessage("No data available");
    settipe('error')
   }
    
  }catch(err){
      setmessage(err.message);
      settipe('errorlog')
  }
}

// function CalculateTotalSubDetail(rakid,rows){
//     var totalHpp = 0;
//     var total = 0;
//    // console.log(rakid.rakid)
//     if(rakid.rakid !== null){
//       var newRows = rows.filter((item) => item.parent_id === rakid.rakid) ;
    
//       if(newRows.length > 0){
//         for(let i = 0;i < newRows.length;i++){
//           totalHpp += parseInt(newRows[i].newhpp)
//           total += parseInt(newRows[i].newtotal)
//         }
       
//         return {totalhpp : parseInt(total /  rakid.newqty), total : parseInt(total)}
//       }else{
//         return {totalhpp : (rakid.newtotal / rakid.newqty),total : rakid.newtotal}
//       }
//     }
//     return {totalhpp : (rakid.newtotal / rakid.newqty),total : rakid.newtotal}
// }

// function GetTotal1(){
//   var  total = 0;
//   var list = rows;
//   for(let i=0; i < list.length; i++){
//     if(list[i].parent_id != null){
//       total += list[i].newtotal
//     }

//     if(list[i].parent_id == null && rows.filter((item)=> item.parent_id == (isExist ? list[i].rakid : list[i].po_detail_id)).length == 0){
//       total += list[i].newtotal
//     }
//   }
  
//   return total;
// }

// function GetTotal2(){
//   var  total = 0;
//    for(let i=0; i < rows.length; i++){
//     total += rows[i].newtotal2
//    }
//    return total;
// }

// function GetTotal3(){
//   var  total = 0;
//   for(let i=0; i < realizationList.length; i++){
//     if(realizationList[i].tipe == 'debit'){
//       total += parseFloat(realizationList[i].debit == '' ? 0 : realizationList[i].debit)
//     }
   
//     if(realizationList[i].tipe == 'credit'){
//       total -= parseFloat(realizationList[i].credit == '' ? 0 : realizationList[i].credit)
//     }
//   }
  
//   return total;
// }
 
const handleChange = async (data=rows) => {
  
   let newList = Array.from(data);
  
   var totalItems=0;
   var totalJasa=0;
   for(var i=0; i < newList.length;i++){
      if(newList[i].raktype =="Item"){
        totalItems += newList[i].newtotal2
      }

      if(newList[i].raktype =="Service"){
        totalJasa += newList[i].newtotal2
      }
   }
   
   sisaAcct = totalJasa;
   seTotalBelanja(totalItems);
   seTotalBelanjaTemp(totalItems);
   setAcct(totalJasa)
   setAcctTemp(totalJasa)
  
};

function HandleLock(){
  seIsLocked(!isLocked);
  if(isLocked == false){
    seTotalBelanja(0)
    setAcct(0)
  }else{
    seTotalBelanja(totalBelanjaTemp)
    setAcct(acctTemp)
  }
}

const handleAddProduct = (data) => {
 
  setRows( // Replace the state
    [ // with a new array
      ...rows, // that contains all the old items
        { 
            rowNumber: rows.length + 1, 
            id : Math.random().toString().split('.')[1],
            descriptions:  data.descriptions,
            name : data.product_name,
            newqty : data.qty,
            newhpp :data.last_buy_price,
            newtotal :data.qty * data.last_buy_price,
            newqty2 :0,
            newhpp2 :0,
            newtotal2 :0,
            unit_id : data.unit_id,
           // part_no : Math.random(),
            raktype:"Item",
            product_type:1,
            part_no:data.part_no,
            isDb:false,
            isChecked : false,
            //code : code[code.length - 1]
            product_id : data.id,
            po_detail_id : -1,
            quotation_id : null,
            code:codeRow,
            rev : revRow,
            parent_id:null,
            rakid:-1
    },
    ]
  );

  handleChange();
}

const handleAddInvoice = (data) => {
  var row = {
            rowNumber: realizationList.length + 1, 
            id : Math.random().toString().split('.')[1],
           // descriptions:  data.deskripsi,
            descriptions:   data.kode,
            //debit : data.total,
            debit : data.amount,
            credit : 0,
            saldo:0,
            tipe: "debit",
            project_id : id
  }

  let newList = Array.from(realizationList);
  newList.push(row);
   
  setRealizationList(CalculateSaldo(newList));
   
}
 
// function calcHeight(e,value) {
//   let numberOfLineBreaks = (value.match(/\n/g) || []).length;
//   let newHeight = 1 + numberOfLineBreaks  
//   document.getElementById(e).rows = newHeight
// }

// function calcHeight2(value) {
//   let numberOfLineBreaks = (value.match(/\n/g) || []).length;
//    // min-height + lines x line-height + padding + border
//   let newHeight =  numberOfLineBreaks  
//   return newHeight;
// }


return (
    <>
  <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={settipe}>
   
  <div className="pd" >
    <p><b>PROJECT</b></p>
  <div style={{backgroundColor:"gray", padding:10, marginBottom:20}}>
   
  <VirtualizedSelect
        options={projectList}
        onChange={(option) => handleSelectedProject(option)}
        value={selectedOptionProject}
        clearable={false}
        searchable={true}
        required
        disabled ={true}
        /><br></br>
        
    </div>
  <Box sx={{ p: 2,m:0, border: '1px solid grey',backgroundColor :"#f6f6f6", marginBottom:3}}>
  <b>TOTAL CONTRACT : {rows.length > 0  ? Helper.formatAsCurrency(totalPo) : 0} </b> 
     {/* <b>TOTAL VALUE OF WORK - CONTRACT : {rows.length > 0  ? Helper.formatAsCurrency(totalPo) : 0} </b>  */}
  </Box>
    <Box>
   {createRak && (
    <div>
       <button
       onClick={() => setCreateRak(false)} // Pass the project ID to the edit function
       className="btn btn-primary mr-2"
       disabled={roleAccess.CREATE == true ? (role == "PM" ? true : false) : !roleAccess.CREATE}
     >
      CREATE RAK  
     </button>
    
     {/* <button
       onClick={() => Navigate(`/Material/${id}${Helper.SetReturnUrl()}`)} // Pass the project ID to the edit function
       className="btn btn-primary mr-2 hide"
       disabled={role == "PM" ? true : false}
     >
      REQUEST MATERIAL 
     </button> */}
     </div>
     
   )}
   
   {!createRak && (
    <div style={{margin:0, padding:0,display:'flex'}}> 
   
        {waitingApproval == 0 ? (
          <>
            <ConfirmationButton classname='btn btn-primary mr-2' text="Do you want save this rak?" type="button" onClick={() => handleAddRakandApproval(!isExist  ? "ADD" : "UPDATE")} title="Save" disabled={roleAccess.UPDATE == true ? (role == "PM" ? true : false) : !roleAccess.UPDATE}>
            {!isExist  ?  ("SAVE RAK"):("UPDATE RAK")} 
            </ConfirmationButton>
            {isExist  &&
            <ConfirmationButton classname='btn btn-danger mr-2' text="Do you want delete this rak?" type="button" onClick={() => handleAddRakandApproval("DELETE")} title="Delete" disabled={roleAccess.DELETE == true ? (role == "PM" ? true : false) : !roleAccess.DELETE}>
              DELETE RAK     
            </ConfirmationButton>
            
            }

          {/* <button
            onClick={() => Navigate(`/Material/${id}${Helper.SetReturnUrl()}`)} // Pass the project ID to the edit function
            className="btn btn-primary mr-2"
           // disabled={role == "PM" ? true : false}
          >
            REQUEST MATERIAL 
          </button> */}
        </>
        ) : (
          <span style={{fontSize:14,fontWeight:"bold",color:"red" }}>.... WAITING FOR APPROVAL</span>
        )}
      
       </div>
       )}
       <br></br> 
    {!createRak ? (
  
      <div>
    <table width={"100%"} border={0} id="tblRAK"  cellSpacing={0} cellPadding={0} >
      <tr>
            <td>
              <Box sx={{boxShadow:5}} >
              <table border={1} style={{width:"100%",fontSize:10,borderColor:"gray"}} cellSpacing={0} cellPadding={0}  id="table1" >
                <tr style={{backgroundColor:"#f4f4f4"}}>
                    <td colSpan={8} style={{textAlign:"center", fontWeight:"bold", backgroundColor:"gray", color:"white", fontSize:14}}>BUDGET PLAN</td>
                     
                    
                </tr>
                <tr>
                   
                    <td style={{width:10, fontWeight:"bold", paddingLeft:5, paddingRight:5}}>No</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Description</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Qty</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Unit</td>
                    <td style={{paddingLeft:10, fontWeight:"bold", width:"15%"}}>HPP</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Total</td>
                    <td style={{paddingLeft:10, fontWeight:"bold"}}>Type</td>
                    <td>&nbsp;</td>
                </tr>
                {code.map((product2, index2) => (
                    //   return (
                   <>
                     <tr>
                         <td colSpan="8" >
                             <table width={"100%"} cellPadding={0} cellSpacing={0} border={0}>
                                 <tr style={{height:20,padding:5}}>
                                     {/* <td style={{height:20,padding:5}}  ><b>#{product2.code} [Rev.{rows.filter((item)=>item.code==product2.code).map((value)=>value.rev)[0]}]</b></td> */}
                                     <td style={{height:20,padding:5}}  ><b>#{product2.code}{product2.code.includes("-") ? " (Additional Work)" : ''}</b></td>
                                     <td style={{height:20,padding:5, textAlign:"right"}}  ><b>  PROJECT VALUE :</b></td>
                                     <td style={{height:20,padding:5, textAlign:"left"}} width={60}><b>{Helper.formatAsCurrency(product2.total_project)}</b></td>
                                 </tr>
                             </table>
                        </td>
                     </tr>
                     {rows.filter((item) => item.code == product2.code && item.parent_id == null).map((product, index) => (
                           <>
                              <tr id={"tr" + index} className='tableTr' key={"key"+index}>
                             
                             <td style={{textAlign:"center"}}><b>{index + 1}</b> </td>
                             <td style={{width:200,padding:10}}>  <textarea
                              type="text"
                              className="form-control resize-ta"
                              placeholder="Description"
                              value={product.descriptions}
                              id={product2.code + index}
                              rows={calcHeight2(product.descriptions)}
                              style={{ fontSize:10, borderWidth:1, overflow:'hidden',resize:'both', width:'100%',display:'block'}}
                              onChange={(e) => handleText(e.target.value, product.id, "desc")}
                              onKeyUp={(e) => calcHeight(product2.code + index, e.target.value)}
                              disabled={product.isDb}
                            /></td>
                              <td style={{width:70,padding:10}}>  <input
                                className="form-control"
                                placeholder="Qty"
                                value={product.newqty}
                                id={index}
                                type="number"
                                min ={0}
                                style={{fontSize:11,borderWidth:0}}
                                required
                                disabled={product.isDb}
                                onChange={(e) => handleText(e.target.value, product.id, "qty")}
                            /></td>
                            <td style={{textAlign: "center", fontSize:12, verticalAlign:"top", width:80,padding:10}}>
                            <VirtualizedSelect
                                options={unitList}
                                onChange={(option) => handleSelectedUnit(option.value, product.id )}
                                value={product.unit_id}
                                clearable={false}
                                searchable={true}
                                disabled={product.isChecked}
                                style={{fontSize:10, borderWidth:1}}
                                required
                                
                            /> 
                            {/* {product.name} */}
                            </td>
                            <td style={{padding:10}}>  
                            {rows.filter((item)=>item.parent_id == (isExist ? product.rakid : product.po_detail_id)).length == 0 && (
                              <input
                              type="text"
                              className="form-control"
                              value={rows.filter((item)=>item.parent_id == (isExist ? product.rakid : product.po_detail_id)).length > 0 ? '' : product.newhpp}
                              //value='aaaa'
                              id={index}
                             // min={0}
                              style={{fontSize:11, borderWidth:1}}
                              required
                              //disabled={rows.filter((item)=>item.parent_id == product.po_detail_id).length > 0 ? true : false}
                              onChange={(e) => handleText(e.target.value, product.id, "hpp")}
                            />
                            )}</td>
                             <td  style={{width:100,padding:10}}>  
                             {rows.filter((item)=>item.parent_id == (isExist ? product.rakid : product.po_detail_id)).length == 0 && (
                              <input
                              type="text"
                              className="form-control"
                             // placeholder="Total"
                              value={rows.filter((item)=> item.parent_id == (isExist ? product.rakid : product.po_detail_id)).length > 0 ? '' :  Helper.formatAsCurrency(product.newtotal)}
                              id={index}
                              style={{fontSize:11,borderWidth:0}}
                              required
                              readOnly
                             // onChange={(e) => handleText(e.target.value, index)}
                            />)}</td>
                            
                                <td style={{textAlign :'center', width:100,padding:10}}  >
                                {rows.filter((item)=>item.parent_id == (isExist ? product.rakid : product.po_detail_id)).length == 0 && (
                                <VirtualizedSelect
                                        options={[{label :"Item", value : 1},{label :"Service", value : 2}]}
                                         onChange={(option) => {
                                          handleText(option.value, product.id, "type")
                                          handleChange()
                                         }}
                                         value={product.product_type}
                                        clearable={false}
                                        searchable={true}
                                        required
                                        disabled={product.isDb}
                                    />)}
                                </td>
                            <td style={{textAlign :'center', width:50}}>
                                {!product.isDb ? ( 
                                    <IconButton   onClick={(evt) => handleDel(evt, index, product)}   disabled={role == "PM" ? true : false} aria-label="fingerprint" color="success" title="Delete"><DeleteIcon sx={{ fontSize: 20 }}/></IconButton >
                                ) : (
                                    <div style={{width:60}}>&nbsp;</div>
                                )}
                            </td>
                          </tr>
                              {rows.filter((item) => item.code == product2.code && item.parent_id == (isExist ? product.rakid : product.po_detail_id)).map((subproduct, index) => (
                                <tr id={"tr" + index} className='tableTr' key={"key"+index}>
                             
                                <td style={{textAlign:"center"}}> </td>
                                <td style={{width:200,padding:10}}>  <textarea
                                 type="text"
                                 className="form-control resize-ta"
                                 placeholder="Description"
                                 value={"   -- " + subproduct.descriptions}
                                 id={product2.code + index}
                                 rows={calcHeight2(subproduct.descriptions)}
                                 style={{ fontSize:10, borderWidth:0, overflow:'hidden',resize:'both', width:'100%',display:'block'}}
                                 onChange={(e) => handleText(e.target.value, subproduct.id, "desc")}
                                 onKeyUp={(e) => calcHeight(product2.code + index, e.target.value)}
                                 disabled={subproduct.isDb}
                               /></td>
                                 <td style={{width:70,padding:10}}>  <input
                                // type="text"
                                 className="form-control"
                                 placeholder="Qty"
                                 value={subproduct.newqty}
                                 id={index}
                                 type="number"
                                 min ={0}
                                 style={{fontSize:11,borderWidth:0}}
                                 required
                                 disabled={subproduct.isDb}
                                 onChange={(e) => handleText(e.target.value, subproduct.id, "qty")}
                               /></td>
                               <td style={{textAlign: "center", fontSize:12, verticalAlign:"top", width:80,padding:10}}>
                               <VirtualizedSelect
                                   options={unitList}
                                   onChange={(option) => handleSelectedUnit(option.value, subproduct.id )}
                                   value={subproduct.unit_id}
                                   clearable={false}
                                   searchable={true}
                                   disabled={subproduct.isChecked}
                                   style={{fontSize:10, borderWidth:1}}
                                   required
                                   
                               /> 
                               {/* {product.name} */}
                               </td>
                               <td style={{width:120}}>
                                  <table width={"100%"}>
                                      <tr>
                                          <td style={{padding:10}}>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Hpp"
                                              value={subproduct.newhpp}
                                              id={index}
                                              style={{fontSize:11, borderWidth:1}}
                                              required
                                              disabled={subproduct.isChecked}
                                              onChange={(e) => handleText(e.target.value, subproduct.id, "hpp")}
                                            />
                                          </td>
                                      </tr>
                                      <tr>
                                          <td style={{paddingLeft:10}}><b>Other Cost :</b></td>
                                      </tr>
                                      <tr>
                                          <td style={{padding:10}}>
                                            <input
                                              type="text"
                                              className="form-control"
                                             // placeholder="Hpp"
                                              value={subproduct.othercost}
                                              id={index}
                                              style={{fontSize:11, borderWidth:1}}
                                              required
                                              disabled={subproduct.isChecked}
                                              onChange={(e) => handleText(e.target.value, subproduct.id, "othercost")}
                                            />
                                          </td>
                                      </tr>
                                  </table>
                                </td>
                                <td  style={{width:100,padding:10}}>  <input
                                 type="text"
                                 className="form-control"
                                 placeholder="Total"
                                 value={Helper.formatAsCurrency(subproduct.newtotal)}
                                 id={index}
                                 style={{fontSize:11,borderWidth:0}}
                                 required
                                 readOnly
                                // onChange={(e) => handleText(e.target.value, index)}
                               /></td>
                               
                                   <td style={{textAlign :'center', width:100,padding:10}}  >
                                   <VirtualizedSelect
                                           options={[{label :"Item", value : 1},{label :"Service", value : 2}]}
                                            onChange={(option) => {
                                             handleText(option.value, subproduct.id, "type")
                                             handleChange()
                                            }}
                                            value={subproduct.product_type}
                                           clearable={false}
                                           searchable={true}
                                           required
                                           disabled={subproduct.isDb}
                                       />
                                   </td>
                               <td style={{textAlign :'center', width:50}}>
                                   {!subproduct.isDb ? ( 
                                       <IconButton   onClick={(evt) => handleDel(evt, index, subproduct)}   disabled={role == "PM" ? true : false} aria-label="fingerprint" color="success" title="Delete"><DeleteIcon sx={{ fontSize: 20 }}/></IconButton >
                                   ) : (
                                       <div style={{width:60}}>&nbsp;</div>
                                   )}
                               </td>
                             </tr>
                              ))}
                            </>
                          ))}
          
                    
                      <tr>
                          <td colSpan={8} style={{textAlign:"right",padding:10}}> 
                          {rows.length > 0  && (  
                            <>
                               <button
                                onClick={() => {
                                  setCodeRow(product2.code)
                                  setRevRow(rows.filter((item)=>item.code==product2.code).map((value)=>value.rev)[0])
                                  setProductopen(true)
                                }} // Pass the project ID to the edit function
                                className="btn btn-primary  mr-2"
                                disabled={role == "PM" ? true : false}
                              >
                                 + ADD ITEM
                               </button>

                              <button
                                onClick={() => handleAdd(product2.code, rows.filter((item)=>item.code==product2.code).map((value)=>value.rev)[0], setRows)} // Pass the project ID to the edit function
                                className="btn btn-info"
                                disabled={role == "PM" ? true : false}
                              >
                                 + ADD SERVICE
                               </button>
                               </>
                             )} </td>
                       </tr>
                      </>
                ))}

                
  
<tr style={{backgroundColor:"#f4f4f4"}}>
      <td colspan="7" align='right' style={{fontSize:12,paddingRight:5}}><b>TOTAL COST</b></td>
      <td style={{fontSize:12,paddingLeft:5}}>{Helper.formatAsCurrency(GetTotal1(rows, isExist))}</td>
    </tr>
    {rows.length > 0 && (
     <tr style={{backgroundColor:"#f4f4f4"}}>
      <td colspan="7" align='right' style={{fontSize:12,paddingRight:5}}>Margin</td>
      <td style={{fontSize:12,paddingLeft:5}}>{Helper.formatAsCurrency(totalPo - GetTotal1(rows, isExist))}</td>
      
    </tr>  
    )}
      {rows.length > 0 && (
     <tr style={{backgroundColor:"#f4f4f4"}}>
      <td colspan="7" align='right' style={{fontSize:12,paddingRight:5}}>Percentage</td>
      <td style={{fontSize:12,paddingLeft:5}}>{(((totalPo - GetTotal1(rows, isExist))  / totalPo) * 100).toFixed(2)} %</td>
    </tr>  
    )}
    
      </table>
      </Box>
                
            </td>
        </tr>
         <tr>
            <td>&nbsp;</td>
         </tr>
        <tr>
          <td>
              <table width="100%" border={1} style={{fontSize:12, display:'none'}}>
                <tr>
                    <td style={{width:300, paddingLeft:5}}>PAYMENT RECEIVED (<b>INVOICES</b>)</td>
                    <td>: {Helper.formatAsCurrency(total)}</td>
                </tr>
                <tr>
                    <td style={{paddingLeft:5}}>TOTAL SERVICES</td>
                    <td>: {Helper.formatAsCurrency(acct)}</td>
                </tr>
                <tr>
                    <td style={{paddingLeft:5}}>TOTAL ITEMS</td>
                    {/* <td>: {totalBelanja || 0}</td> */}
                    <td>
                      <table width="100%">
                        <tr>
                            <td>: {totalBelanja|| 0}</td>
                            <td className='hide'><button
                                  onClick={() => HandleLock()} // Pass the project ID to the edit function
                                  disabled={role == "PM" ? true : false}
                                  height={50}
                                  >
                                    {!isLocked  ? "LOCK" : "UNLOCK"}
                            </button></td>
                        </tr>
                      </table>
                    </td>
                </tr>
                <tr>
                    <td style={{paddingLeft:5}}>TOTAL</td>
                    <td>: {Helper.formatAsCurrency(parseInt(totalBelanja || 0) + parseInt(acct))}</td>
                </tr>
                <tr>
                    <td style={{paddingLeft:5}}>PROFIT</td>
                    <td>: {Helper.formatAsCurrency(total - (parseInt(totalBelanja || 0) + parseInt(acct)))}</td>
                </tr>
              </table>
          </td>
        </tr>
    </table>
    <br></br>

<Box sx={{ boxShadow:5}}>
    <table border={0} style={{width:"100%",fontSize:10,borderColor:"gray" }} id="tblRAK"  >
    
    <tr>
      <td colspan="7" align='right'>
        <table width="100%"  border={1} > 
        <tr>
          <td colspan="6" align='center' style={{padding:3, backgroundColor:"gray", color:"white", fontSize:14}}><b>REALIZATION</b></td>
        </tr>
                <tr style={{backgroundColor:"#f4f4f4" }}>
                    <td style={{padding:2,textAlign:"center" }}><b>No</b></td>
                    <td style={{padding:2 }}><b>RAK Implementation</b></td>
                    <td style={{padding:2 }}><b>Debit</b></td>
                    <td style={{padding:2 }}><b>Credit</b></td>
                    <td style={{padding:2 }}><b>Balance</b></td> 
                    <td></td> 
                </tr>
                {realizationList.map((item, index) => (
                  <tr  style={{backgroundColor:"white"}}>
                    <td style={{textAlign:"center" }}>{index + 1}</td>
                    <td style={{padding:10}}>
                    <textarea
                              type="text"
                              className="form-control"
                              placeholder="RAK Implementation"
                               value={item.descriptions}
                              id={index}
                            //  rows={calcHeight2(product.descriptions)}
                              style={{ fontSize:10, borderWidth:1, overflow:'hidden',resize:'both', width:'100%',display:'block'}}
                              onChange={(e) => handleText(e.target.value, item.id, "description")}
                              //onKeyUp={(e) => calcHeight(product2.code + index, e.target.value)}
                            />
                    </td>
                    <td style={{padding:10}}>
                    <input
                              type="text"
                              className="form-control"
                              placeholder="Debit"
                              value={ item.debit == '' ? 0 : Helper.formatAsCurrency(item.debit) }
                              id={'txtDebit' + item.id}
                             // min={0}
                              
                              style={{fontSize:11, borderWidth:0}}
                              required
                              disabled ={true}
                             // disabled ={item.credit > 0 ? item.debit }
                              //disabled={item.debit == 0 &&  item.credit ==0 ? false : (item.debit > 0 ? false : true)}
                              onChange={(e) => handleText(e.target.value.replaceAll(',',''), item.id, "debit")}
                            />
                    </td>
                    <td style={{padding:10}}> <input
                              type="text"
                              className="form-control"
                              placeholder="Credit"
                              value={ item.credit == '' ? 0 : Helper.formatAsCurrency(item.credit)}
                              id={'txtCredit' + item.id}
                             // min={0}
                              style={{fontSize:11, borderWidth:1}}
                              required
                               disabled={item.credit == 0 &&  item.debit ==0 ? false : (item.credit > 0 ? false : true)}
                              onChange={(e) => handleText(e.target.value.replaceAll(',',''), item.id, "credit")}
                            /></td>
                    <td style={{padding:10}}> <input
                              type="text"
                              className="form-control"
                              placeholder="Saldo"
                              value={item.credit == 0 &&  item.debit ==0 ? 0 : Helper.formatAsCurrency(item.saldo)}
                              id={index}
                          
                              style={{fontSize:11, borderWidth:0}}
                              required
                              disabled={true}
                             // onChange={(e) => handleText(e.target.value, product.id, "saldo")}
                            /></td> 
                            <td style={{padding:10, textAlign:'center'}}>
                            <IconButton   onClick={(evt) => handleDelRealization(item.id)}   disabled={role == "PM" ? true : false} aria-label="fingerprint" color="success" title="Delete"><DeleteIcon sx={{ fontSize: 20 }}/></IconButton >
                            </td>
                  </tr>
                ))}
                
                 
                <tr>
                  <td colSpan={7}  style={{textAlign:"right",padding:10, backgroundColor:'white'}}>
                  <button
                                 onClick={(e) => setInvoiceopen(true)} // Pass the project ID to the edit function
                                className="btn btn-primary mr-2"
                                disabled={role == "PM" ? true : false}
                              >
                                 + ADD INVOICE
                               </button>
                  <button
                                 onClick={() => handleAddRealization(setRealizationList, id)} // Pass the project ID to the edit function
                                className="btn btn-info"
                                disabled={role == "PM" ? true : false}
                              >
                                 + ADD
                               </button>
                  </td>
                </tr>
                {rows.length > 0 && (
                  <>
                  <tr style={{backgroundColor:"#f4f4f4"}}>
                    <td colspan="4" align='right' style={{fontSize:12,paddingRight:5}}><b>BALANCE</b></td>
                    <td colspan="2"  style={{fontSize:12,paddingLeft:15}}>{Helper.formatAsCurrency(GetTotal3(realizationList))}</td>
     
                  </tr>  
                  <tr style={{backgroundColor:"#f4f4f4"}}>
                    <td colspan="4" align='right' style={{fontSize:12,paddingRight:5}}>Percentage</td>
                    <td colspan="2" style={{fontSize:12,paddingLeft:15}}>{((GetTotal3(realizationList)/ totalPo) * 100).toFixed(2)}</td>
     
                  </tr>  
                  </>
                  
    
                )}
        </table>
      </td>
       
    </tr>
    
    
    </table></Box><br></br>
    </div>
    ) : (
      <Box  sx={{ borderTop: 1, borderColor: 'gray',paddingTop:2, textAlign:"center",color:"red" }}>
            
             <label >RAK HASN'T BEEN CREATED</label>
      </Box >
   
    )}
    </Box>
   
    </div>

    </Layout>
    <Bindcomponent component='ProductDialog' productopen={productopen} productclose={setProductopen} handleProductDialog={handleAddProduct}></Bindcomponent>
    <Bindcomponent component='InvoiceDialog' invoiceopen={invoiceopen} invoiceclose={setInvoiceopen} handleInvoiceDialog={handleAddInvoice} id={id}></Bindcomponent>
    {/* <ProductDialog productopen={productopen} productclose={setProductopen} handleProductDialog={handleAddProduct}></ProductDialog>
    <InvoiceDialog invoiceopen={invoiceopen} invoiceclose={setInvoiceopen} handleInvoiceDialog={handleAddInvoice} id={id}></InvoiceDialog> */}
    </>
  );
};

export default Rak;